import {
  MapMarkerType,
} from '../../../../store/mst/models';

export enum LayerType {
  BASE = 'base',
  TEXT = 'text',
  OUTLINE = 'outline',
  STATUS = 'status',
}

export const STYLE_MAP = {
  common: {
    active: {
      marker: 56,
      text: 17,
      offset: -29,
    },
    base: {
      marker: 40,
      text: 13,
      offset: -21,
    },
  },
  event: {
    active: {
      marker: 80,
      text: 25,
      offset: -44,
    },
    base: {
      marker: 60,
      text: 22,
      offset: -33,
    },
  },
};

export const getRanges = (array: number[], separator = ' \u2013 ') => array
  .slice()
  .sort((a: number, b: number) => a - b).reduce((ranges: { min: number, max: number }[], value: number) => {
    const lastIndex = ranges.length - 1;
    if (lastIndex === -1 || ranges[lastIndex].max !== value - 1) {
      ranges.push({ min: value, max: value });
    } else {
      ranges[lastIndex].max = value;
    }
    return ranges;
  }, [])
  .map((range) => (range.min !== range.max ? range.min + separator + range.max : range.min.toString()));

export const getPixelOffset = (d: MapMarkerType, active: boolean) => {
  let offset;

  if (d.properties.type !== 'delivering_stop') {
    offset = active ? [0, STYLE_MAP.event.active.offset] : [0, STYLE_MAP.event.base.offset];
  } else {
    offset = active ? [0, STYLE_MAP.common.active.offset] : [0, STYLE_MAP.common.base.offset];
  }

  return offset;
};

export const getContentSize = (d: MapMarkerType, layerType: LayerType, active: boolean) => {
  let size;
  if (layerType === LayerType.STATUS && d.properties.type !== 'delivering_stop') {
    size = active ? STYLE_MAP.event.active.text : STYLE_MAP.event.base.text;
  } else {
    size = active ? STYLE_MAP.common.active.text : STYLE_MAP.common.base.text;
  }

  return size;
};

export const getMarkerSize = (d: MapMarkerType, active: boolean) => {
  let size;
  if (d.properties.type !== 'delivering_stop') {
    size = active ? STYLE_MAP.event.active.marker : STYLE_MAP.event.base.marker;
  } else {
    size = active ? STYLE_MAP.common.active.marker : STYLE_MAP.common.base.marker;
  }

  return size;
};

const MAX_MARKER_LENGTH = 18;

export const getMarkerText = (d: MapMarkerType) => {
  let text;

  const isNumberedStop = d.properties.type === 'delivering_stop';

  if (isNumberedStop) {
    if (d.properties.cluster) {
      text = getRanges(d.properties.itemsSequence || [])?.join(', ');
    } else {
      text = d.properties?.sequence?.toString();
    }
  }

  return text || '';
};

export const getMarkerLength = (d: MapMarkerType): string => {
  let length;
  if (d.properties.type === 'delivering_stop') {
    const sequenceLength = getMarkerText(d)?.replace(', ', '').replace('–', '').length || 1;
    length = sequenceLength <= MAX_MARKER_LENGTH ? sequenceLength.toString() : `${MAX_MARKER_LENGTH}`;
  }
  return length || '1';
};
